import type { ChangeEvent } from 'react';
import { Button, Select } from '../ui';

interface SelectionToolbarProps {
  allSelected: boolean;
  availablePermissions: Array<any>;
  selectedItems: Array<number>;
  showBlockingLoader: boolean;
  selectAll: () => void;
  filterByGroup: (e: ChangeEvent<HTMLSelectElement>) => void;
  deleteSelected: () => void;
}

const SelectionToolbar = ({
  allSelected,
  availablePermissions,
  selectedItems,
  showBlockingLoader,
  selectAll,
  filterByGroup,
  deleteSelected,
}: SelectionToolbarProps) => (
  <div className="flex flex-wrap gap-4 mt-5 mb-10">
    <Button className="py-2.5" onClick={selectAll}>
      <div
        className={`${
          allSelected ? 'bg-default border-default' : 'bg-white border-suzy-gray'
        } grid p-0.5 content-center inline-block w-4 h-4 mr-2 border rounded cursor-pointer `}
      >
        {allSelected && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="white"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m4.5 12.75 6 6 9-13.5"
            />
          </svg>
        )}{' '}
      </div>
      <span className="text-gray-500">Select all</span>
    </Button>
    {availablePermissions.length > 0 && (
      <Select name="permissions" id="permissions" onChange={filterByGroup}>
        <option value="all">All groups</option>
        {availablePermissions.map((permission) => (
          <option key={permission.ID} value={permission.ID}>
            {permission.name}
          </option>
        ))}
      </Select>
    )}
    {selectedItems.length > 0 && (
      <Button
        className="py-2.5 text-default"
        disabled={showBlockingLoader}
        onClick={deleteSelected}
      >
        <span className="text-gray-500">Delete selected</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          className="w-4 stroke-red-500"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
      </Button>
    )}
  </div>
);

export default SelectionToolbar;
